<template lang="pug">
  el-container(style="height: 100vh")
    globalSidebar(@sendTitle="getTitle")
    el-container(class="is-vertical")
      globalHeader
      el-main#main-view(style="padding: 0")
        transition(name="fade")
          router-view
      globalFooter
</template>

<script>
import axios from 'axios'
import Store from '@/store/index.js'
import Header from './Header.vue'
import SideBar from './SideBar.vue'
import Footer from './Footer.vue'
import UserApi from '@/api/user'
import { mapState, mapGetters } from 'vuex'
export default {
  data () {
    return {
      user: null,
      managers: [],
      isLoading: true,
      complateGetUser: false,
      complateGetServices: false,
      notificationChannel: null,
    }
  },
  store: Store,
  created() {
    this.getUserManagersServices();

    this.isLoading = this.$loading({
      lock: true,
      text: 'Loading',
      customClass: 'loading',
      background: 'rgba(255, 255, 255, 0.8)'
    })

    // CUONA購入申請通知を受け取り
    // const that = this;
    // this.notificationChannel = this.$cable.subscriptions.create('NotificationChannel', {
    //   received (data) {
    //     if(data.notification.company_id == that.company.id && that.user.role === 'owner') {
    //       that.notifyDeviceRequest(data.notification);
    //     }
    //   }
    // })
  },
  components: {
    'globalHeader': Header,
    'globalSidebar': SideBar,
    'globalFooter': Footer
  },
  computed: {
    ...mapGetters([
      'company'
    ]),
  },
  methods: {

    getUserManagersServices: function (){
      const that = this;
      Promise.all([UserApi.getUser(), UserApi.getManagers()])
        .then(function(values) {
          that.$store.commit('setUser', values[0]);  // for header
          that.user = values[0];
          that.managers = values[1];
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('user.failed_get'),
            type: 'error'
          });
        })
        .finally(() => { this.isLoading.close(); });
    },

    // ヘッダータイトルの変更
    getTitle: function (title){
      this.title = title;
    },

    // CUONA購入申請の通知を表示
    notifyDeviceRequest(notification) {
      console.log(notification)
      let manager = this.managers.find(function(manager) {
        return manager.id == notification.user_id
      })
      this.$notify({
        title: 'CUONA購入申請',
        dangerouslyUseHTMLString: true,
        message: `申請者：${manager.name}<br>
                  キューブ：${notification.cube_count}個<br>
                  タグ：${notification.tag_count}個`,
        position: 'top-right',
        duration: 0
      });
    }
  }
}
</script>

<style lang="scss">
.fade-enter-active {
  transition: opacity .2s;
}
.fade-enter {
  opacity: 0;
}

.loading {
  color: #FFF;
}

img.device-image {
  position: relative;
  top:4px;
  width: 20px;
  margin-right: 8px;
}

.content {
  padding: 5px 0;
}

.el-tabs__header {
  margin: 0 0 40px;
}

.el-dialog {
  border-radius: 6px;
}
.el-dialog__header {
  padding: 25px 20px 0 20px;
}
.el-dialog__body {
  padding: 10px 20px 20px 20px;
}
.el-tabs__item {
  color: #999;
}
</style>
